module.exports = __webpack_public_path__ + "public/img/finish.c22d0c19.jpeg";